import request from '@/utils/request'
import qs from 'qs'

/**
 * 新建文件夹
 *
 * @param {object} params 包含创建文件夹时的数据模型
 */
export function insertFileFolder (params) {
  return request({
    url: '/op/opApp/newFolder',
    method: 'post',
    data: params
  })
}

/**
 * 删除文件
 *
 * @param {long} id 文件id
 */
export function deleteFile (params) {
  return request({
    url: '/op/opApp/delete',
    method: 'post',
    data: params
  })
}

/**
 * 删除文件
 *
 * @param {long} id 文件id
 */
export function ljApp (params) {
  return request({
    url: '/op/opApp/ljApp',
    method: 'post',
    data: params
  })
}

/**
 * 重命名文件
 *
 * @param {*} params 重命名文件需要的参数
 */
export function renameFile (params) {
  return request({
    url: '/op/opApp/update',
    method: 'post',
    data: params
  })
}

/**
 * 重命名文件
 *
 * @param {*} params 重命名文件需要的参数
 */
export function updateFolderName (params) {
  return request({
    url: '/op/opApp/updateFolderName',
    method: 'post',
    data: params
  })
}

/**
 * 复制文件
 *
 * @param {*} params 复制文件需要的参数
 */
export function copyFile (params) {
  return request({
    url: '/disk-file/copy-file',
    method: 'post',
    data: qs.stringify(params)
  })
}

/**
 * 移动文件
 *
 * @param {*} params 移动文件需要的参数
 */
export function moveFile (params) {
  return request({
    url: '/op/opApp/delete',
    method: 'post',
    data: params
  })
}

/**
 * 文件搜索、检索文件、获取文件列表
 *
 * @param {object} params 包含需要搜索的文件参数信息
 */
export function search (params) {
  return request({
    url: '/op/opApp/list',
    method: 'post',
    data: params
  })
}

/**
 * 文件下载
 *
 * @param {object} params 包含下载参数信息
 */
export function download (params) {
  return request({
    url: '/disk-file/resource',
    method: 'get',
    params
  })
}

/**
 * 开放平台校验用户是否可以上传apk
 *
 * @param {object} params 包含下载参数信息
 */
export function checkApkCount (params) {
  return request({
    url: '/op/opApp/checkApkCount',
    method: 'POST',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/file.js